import React, { useState } from 'react'
import Footer from '../../comps/Footer'
import Header from '../../comps/Header'
import Select from "react-select";
import { add_addresses } from '../../api/Product';
import Country_State_Data from '../country_state_data/Country_State_Data';
import { useNavigate } from 'react-router-dom';
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const Shipping_Address = () => {
    const navigate = useNavigate();
    //  Convert countries into react-select format
    const countryOptions = Object.entries(Country_State_Data).map(([code, details]) => ({
        value: code,
        label: details.name,
    }));

    const [formData, setFormData] = useState({
        type: "shipping",
        fullName: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        phone: ''
    });
    const [phoneError, setPhoneError] = useState("");


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Phone number change handler
    const handlePhoneChange = (phone) => {
        setFormData({ ...formData, phone });

        // Validate phone immediately
        if (!phone || !isValidPhoneNumber(phone)) {
            setPhoneError("Please enter a valid phone number.");
        } else {
            setPhoneError("");
        }
    };

    // Handle Country Selection
    const handleCountryChange = (selectedOption) => {
        setFormData({ ...formData, country: selectedOption, state: null });
    };

    // Handle State Selection
    const handleStateChange = (selectedOption) => {
        setFormData({ ...formData, state: selectedOption });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const headers = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            };
            // Convert state & country to string before sending
            const payload = {
                ...formData,
                state: formData.state?.value || "",
                country: formData.country?.value || "",
            };

            const response = await add_addresses(payload, headers);
            console.log("Response:", response);
            navigate("/my-account")
            setFormData({
                fullName: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                phone: '',
            });

        } catch (error) {
            console.error("Error submitting form", error);
        }
    };


    return (
        <div>
            {/*  */}
            <Header />
            <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
                <div className="bg-white shadow-md rounded-lg w-full max-w-lg">
                    <div className="px-6 py-4 border-b">
                        <h2 className="text-2xl font-bold text-gray-800">Shipping Address</h2>
                    </div>
                    <form onSubmit={handleSubmit} className="px-6 py-4">
                        {/* Full Name */}
                        <div className="mb-4">
                            <label htmlFor="fullName" className="block text-gray-700 mb-2">Full Name</label>
                            <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="John Doe" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300"    />
                        </div>

                        {/* Address */}
                        <div className="mb-4">
                            <label htmlFor="address" className="block text-gray-700 mb-2">Address</label>
                            <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} placeholder="123 Main St" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300" />
                        </div>


                        <div className="mb-4 grid grid-cols-1 md:grid-cols-1 gap-4">
                            {/* Country Selection */}
                            <div>
                                <label className="block text-gray-700 mb-2">Country *</label>
                                <Select className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring focus:border-amber-300" options={countryOptions} value={countryOptions.find(option => option.value === formData.country?.value)} onChange={(selectedOption) => setFormData({ ...formData, country: selectedOption, state: null })} placeholder="Select a country..."
                                    styles={{
                                        control: (provided) => ({ ...provided, border: "none", boxShadow: "none" }),
                                        dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                                    }}
                                />
                            </div>

                            {/* State Selection - Only Show When Country is Selected */}
                            {formData.country && Country_State_Data[formData.country.value] && (
                                <div>
                                    <label className="block text-gray-700 mb-2">State *</label>
                                    <Select className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring focus:border-amber-300" options={Country_State_Data[formData.country.value]?.states.map((state) => ({ value: state, label: state }))} value={formData.state} onChange={(selectedOption) => setFormData({ ...formData, state: selectedOption })} placeholder="Select a state..."
                                        styles={{
                                            control: (provided) => ({ ...provided, border: "none", boxShadow: "none" }),
                                            dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                                        }}
                                    />
                                </div>
                            )}
                        </div>


                        {/* ZIP Code and Country */}
                        <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label htmlFor="zip" className="block text-gray-700 mb-2">ZIP Code</label>
                                <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} placeholder="ZIP Code" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300"
                                />
                            </div>
                            <div>
                                <label htmlFor="city" className="block text-gray-700 mb-2">City</label>
                                <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} placeholder="City" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300"
                                />
                            </div>
                        </div>
                        {/* <div>
                            <label htmlFor="phone" className="block text-gray-700 mb-2">Phone</label>
                            <input type="number" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" required className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring focus:border-amber-300"
                            />
                        </div> */}
                        <div>
                            <label className="block text-sm font-medium text-gray-400 mb-1">Phone:</label>
                            <PhoneInput defaultCountry="US" placeholder="Enter phone number" value={formData.phone} onChange={handlePhoneChange} className="w-full rounded-lg h-10 px-4 text-sm placeholder:text-gray-500 border border-gray-200 focus:border-stone-300 focus:ring-1 focus:ring-stone-200" />
                            {phoneError && (
                                <p className="text-red-500 text-xs mt-1">{phoneError}</p>
                            )}

                        </div>
                        {/* Save Button */}
                        <div className="flex justify-end mt-3">
                            <button type="submit" className="bg-amber-600 text-white px-6 py-2 rounded-md hover:bg-amber-700">
                                Save Address
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/*  */}
            <Footer />
        </div>
    )
}

export default Shipping_Address
